import React from "react";
import { Alert, Button, Card, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import Loader from "../../../components/Loader";
import { deleteCustomerAccount } from "../../../_redux/actions/ActionUser";

const bg = {
  background: "url('/assets/images/background.jpg') no-repeat",
  backgroundSize: "cover",
};

const DeleteAccount = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const deviceID = searchParams.get("deviceID");
  const loading = useSelector((state) => state.ui.loading);
  const isDeviceMissing = !deviceID;

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "onBlur" });

  const onSubmit = (data) => {
    if (isDeviceMissing) {
      return;
    }
    dispatch(
      deleteCustomerAccount(
        { date_of_birth: data.date_of_birth, deviceID },
        history
      )
    );
  };

  return (
    <div className="login">
      {loading && <Loader />}
      <div className="login__wrapper" style={bg}>
        <div className="login__form">
          <div className="d-flex justify-content-center login_logo">
            <img
              src="/assets/images/Logo_Light Mode.svg"
              alt="logo"
              className="logo"
            />
          </div>
          <h3 className="text-center text-danger font-weight-bold mb-3">
            Delete Account
          </h3>
          <Card>
            <Card.Body>
              <Alert variant="danger">
                <h6 className="font-weight-bold mb-2">This action is permanent.</h6>
                <p className="mb-0">
                  Deleting your account will remove all of your customer data,
                  conversations, and purchase history. This cannot be undone.
                </p>
              </Alert>
              {!deviceID && (
                <Alert variant="warning" className="mb-3">
                  Missing device identifier. Please open this link from the
                  mobile app settings to proceed.
                </Alert>
              )}
              {deviceID && (
                <Alert variant="secondary" className="mb-3">
                  Device ID detected: <strong>{deviceID}</strong>
                </Alert>
              )}
              <Form className="mt-3" onSubmit={handleSubmit(onSubmit)}>
                <Form.Group controlId="delete-account-date-of-birth">
                  <Form.Label>Enter your date of birth</Form.Label>
                  <Form.Control
                    type="date"
                    placeholder="YYYY-MM-DD"
                    isInvalid={!!errors.date_of_birth}
                    disabled={loading}
                    {...register("date_of_birth", {
                      required: "Date of birth is required",
                    })}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.date_of_birth?.message}
                  </Form.Control.Feedback>
                </Form.Group>
                <Button
                  type="submit"
                  variant="danger"
                  className="btn-round w-100"
                  disabled={loading || isDeviceMissing}
                >
                  Permanently Delete Account
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default DeleteAccount;
